import { IconMarkerLocationSection } from 'components/minute/sidebar/MarkerSidebar/IconMarkerSiderbar/IconMarkerLocationSection';
import { MarkerControlsSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerControlsSection';
import { MarkerFloorSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerFloorSection';
import { VariantIconMarkerLabelSection } from 'components/minute/sidebar/MarkerSidebar/VariantIconMarkerSidebar/VariantIconMarkerLabelSection';
import { VariantIconMarkerStyleSection } from 'components/minute/sidebar/MarkerSidebar/VariantIconMarkerSidebar/VariantIconMarkerStyleSection';
import { IVariantIconV2WorldMarker } from 'react-give-me-map';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: IVariantIconV2WorldMarker;
}

export const VariantIconMarkerSidebar = (props: Props): JSX.Element => {
    return (
        <S_IconMarkerSidebar className={props.className}>
            <VariantIconMarkerLabelSection marker={props.marker} />
            <VariantIconMarkerStyleSection marker={props.marker} />
            <IconMarkerLocationSection marker={props.marker} />
            <MarkerFloorSection marker={props.marker} />
            <MarkerControlsSection marker={props.marker} />
        </S_IconMarkerSidebar>
    );
};

const S_IconMarkerSidebar = styled.div``;
